var map = {
	"./base-1.fbx": 312,
	"./base-12.fbx": 1232,
	"./base-18.fbx": 2104,
	"./base-24.fbx": 8760,
	"./base-4.fbx": 4264,
	"./base-8.fbx": 9256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6756;